import { z } from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
} from '../shared/schema'
import { RubricType, RubricTypeReverseMap } from '../PromptRubricType/types'

export const schema = z.object({
  endedAt: nullSafeOptionalFirestoreTimestamp(),
  promptType: z.string(), // Store as string to match Go server expectation
  promptVersionId: z.string(),
  roomId: z.string(),
  startedAt: nullSafeOptionalFirestoreTimestamp(),
  success: nullSafeOptionalBoolean(),
  startSlideId: nullSafeOptionalString(),
  slideId: nullSafeOptionalString(),
  rubricPrompt: nullSafeOptionalString(),
  // Learning objective tests grade against a title, description and
  // per-score criteria (index = score) instead of rubricPrompt.
  rubric: nullSafeOptionalString(),
  rubricDescription: nullSafeOptionalString(),
  rubricScoreCriteria: z.array(z.string()).nullish(),
  hidden: nullSafeOptionalBoolean(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: RubricTypeReverseMap[RubricType.blooms], // Use string representation
    roomId: '',
    promptVersionId: '',
    startSlideId: '',
    slideId: '',
    rubricPrompt: '',
  })
)

export type FirestorePromptRubricAIEvent = z.infer<typeof schema>
